export default {"src":"/_next/static/media/icone-helio.db97273f.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};